import common from './common';
import jobs from './jobs';
import myAccounts from './myAccounts';
import tutorialsCommon from './tutorials/common';
import dashboardOverview from './tutorials/dashboardOverview';
import searchResultsJobs from './tutorials/searchResultsJobs';
import tutorialsSearch from './tutorials/search';
import paginationTutorials from './tutorials/pagination';
import jobsTable from './tutorials/jobsTable';
import tutorialsTemplates from './tutorials/templates';
import tutorialsTemplatesLanding from './tutorials/templatesLanding';
import tutorialsInvoices from './tutorials/invoices';
import headTutorials from './tutorials/head';
import customReportsTutorials from './tutorials/customReports';
import jobsTutorials from './tutorials/jobs';
import editColumnsTutorials from './tutorials/editColumns';
import ordersTutorials from './tutorials/orders';
import suppliesTutorials from './tutorials/supplies';
import dash from './dash';
import head from './head';
import formsDetails from './formsDetails';
import formsOrderSamples from './formsOrderSamples';
import formsSupplies from './formsSupplies';
import formsTests from './formsTests';
import nav from './nav';
import footer from './footer';
import confirmation from './confirmation';
import orders from './orders';
import overview from './overview';
import templates from './templates';
import invoices from './invoices';
import invoicesPaymentSummary from './invoicesPaymentSummary';
import terms from './terms';
import invoicesPaymentConfirmation from './invoicesPaymentConfirmation';
import invoicesPaymentDetails from './invoicesPaymentDetails';
import emailNotifications from './emailNotifications';
import loginAsAdmin from './loginAsAdmin';
import reportForms from './reportForms';
import jobsDetail from './jobsDetail';
import formsShipping from './formsShipping';
import formsLabels from './formsLabels';
import labelPreview from './labelPreview';
import reports from './reports';
import formsSamples from './formsSamples';
import multiDeletion from './multiDeletion';
import pagination from './pagination';
import manageAccess from './manageAccess';
import urls from './urls';
import privacy from './privacy';
import editColumns from './editColumns';
import formsSummary from './formsSummary';
import formsOrderSummaryDesktopSampleIDs from './formsOrderSummaryDesktopSampleIDs';
import formsOrderSummaryDesktopQcSampleIDs from './formsOrderSummaryDesktopQcSampleIDs';
import formsDetailsInvoiceChange from './formsDetailsInvoiceChange';
import globalSearch from './globalSearch';
import menuOptions from './menuOptions';
import confirmModal from './confirmModal';
import editJob from './editJob';
import additionalAnalysis from './additionalAnalysis';
import login from './login';
import loginLayout from './loginLayout';
import regions from './regions';
import forgot from './forgot';
import verification from './verification';
import registration from './registration';
import languages from './languages';
import formsPayment from './formsPayment';
import prepaidRequest from './prepaidRequest';
import splitReports from './splitReports';
import splitReportsStep1 from './splitReportsStep1';

/*
  Key names which are complete sentences/paragraphs and use '.' (full-stop) must use &#46; instead
  in order to lookup successfully. Their returned value may use '.' (full-stop) as normal.
*/

export default {
  E: {
    splitReports: splitReports.E,
    common: common.E,
    myAccounts: myAccounts.E,
    overview: overview.E,
    editJob: editJob.E,
    tutorials: {
      common: tutorialsCommon.E,
      dashboardOverview: dashboardOverview.E,
      searchResultsJobs: searchResultsJobs.E,
      pagination: paginationTutorials.E,
      jobsTable: jobsTable.E,
      templates: tutorialsTemplates.E,
      head: headTutorials.E,
      search: tutorialsSearch.E,
      invoices: tutorialsInvoices.E,
      customReports: customReportsTutorials.E,
      jobs: jobsTutorials.E,
      editColumns: editColumnsTutorials.E,
      tutorialsTemplatesLanding: tutorialsTemplatesLanding.E,
      orders: ordersTutorials.E,
      supplies: suppliesTutorials.E,
    },
    dash: dash.E,
    head: head.E,
    formsDetails: formsDetails.E,
    formsOrderSamples: formsOrderSamples.E,
    formsSupplies: formsSupplies.E,
    formsTests: formsTests.E,
    nav: nav.E,
    footer: footer.E,
    confirmation: confirmation.E,
    invoicesPaymentSummary: invoicesPaymentSummary.E,
    invoicesPaymentConfirmation: invoicesPaymentConfirmation.E,
    invoicesPaymentDetails: invoicesPaymentDetails.E,
    jobs: jobs.E,
    orders: orders.E,
    templates: templates.E,
    terms: terms.E,
    invoices: invoices.E,
    emailNotifications: emailNotifications.E,
    loginAsAdmin: loginAsAdmin.E,
    reportForms: reportForms.E,
    jobsDetail: jobsDetail.E,
    formsShipping: formsShipping.E,
    formsLabels: formsLabels.E,
    labelPreview: labelPreview.E,
    reports: reports.E,
    formsSamples: formsSamples.E,
    pagination: pagination.E,
    manageAccess: manageAccess.E,
    urls: urls.E,
    editColumns: editColumns.E,
    formsSummary: formsSummary.E,
    formsOrderSummaryDesktopSampleIDs: formsOrderSummaryDesktopSampleIDs.E,
    formsOrderSummaryDesktopQcSampleIDs: formsOrderSummaryDesktopQcSampleIDs.E,
    formsDetailsInvoiceChange: formsDetailsInvoiceChange.E,
    privacy: privacy.E,
    globalSearch: globalSearch.E,
    menuOptions: menuOptions.E,
    confirmModal: confirmModal.E,
    additionalAnalysis: additionalAnalysis.E,
    login: login.E,
    layout: {
      login: loginLayout.E,
    },
    regions: regions.E,
    forgot: forgot.E,
    verification: verification.E,
    registration: registration.E,
    languages: languages.E,
    multiDeletion: multiDeletion.E,
    formsPayment:formsPayment.E,
    prepaidRequest:prepaidRequest.E,
    splitReportsStep1:splitReportsStep1.E
  },
  F: {
    splitReports: splitReports.F,
    privacy: privacy.F,
    common: common.F,
    myAccounts: myAccounts.F,
    overview: overview.F,
    editJob: editJob.F,
    tutorials: {
      common: tutorialsCommon.F,
      dashboardOverview: dashboardOverview.F,
      searchResultsJobs: searchResultsJobs.F,
      pagination: paginationTutorials.F,
      jobsTable: jobsTable.F,
      templates: tutorialsTemplates.F,
      head: headTutorials.F,
      search: tutorialsSearch.F,
      invoices: tutorialsInvoices.F,
      customReports: customReportsTutorials.F,
      jobs: jobsTutorials.F,
      editColumns: editColumnsTutorials.F,
      tutorialsTemplatesLanding: tutorialsTemplatesLanding.F,
      orders: ordersTutorials.F,
      supplies: suppliesTutorials.F,
    },
    dash: dash.F,
    head: head.F,
    formsDetails: formsDetails.F,
    formsOrderSamples: formsOrderSamples.F,
    formsSupplies: formsSupplies.F,
    formsTests: formsTests.F,
    nav: nav.F,
    footer: footer.F,
    invoicesPaymentSummary: invoicesPaymentSummary.F,
    invoicesPaymentConfirmation: invoicesPaymentConfirmation.F,
    invoicesPaymentDetails: invoicesPaymentDetails.F,
    jobs: jobs.F,
    confirmation: confirmation.F,
    orders: orders.F,
    templates: templates.F,
    terms: terms.F,
    invoices: invoices.F,
    emailNotifications: emailNotifications.F,
    loginAsAdmin: loginAsAdmin.F,
    reportForms: reportForms.F,
    jobsDetail: jobsDetail.F,
    formsShipping: formsShipping.F,
    formsLabels: formsLabels.F,
    labelPreview: labelPreview.F,
    reports: reports.F,
    formsSamples: formsSamples.F,
    pagination: pagination.F,
    manageAccess: manageAccess.F,
    urls: urls.F,
    editColumns: editColumns.F,
    formsSummary: formsSummary.F,
    formsOrderSummaryDesktopSampleIDs: formsOrderSummaryDesktopSampleIDs.F,
    formsOrderSummaryDesktopQcSampleIDs: formsOrderSummaryDesktopQcSampleIDs.F,
    formsDetailsInvoiceChange: formsDetailsInvoiceChange.F,
    globalSearch: globalSearch.F,
    menuOptions: menuOptions.F,
    confirmModal: confirmModal.F,
    additionalAnalysis: additionalAnalysis.F,
    login: login.F,
    layout: {
      login: loginLayout.F,
    },
    regions: regions.F,
    forgot: forgot.F,
    verification: verification.F,
    registration: registration.F,
    languages: languages.F,
    multiDeletion: multiDeletion.F,
    formsPayment:formsPayment.F,
    prepaidRequest:prepaidRequest.F,
    splitReportsStep1:splitReportsStep1.F
  },
};



// WEBPACK FOOTER //
// ./src/constants/translations/index.js